<ng-container *ngIf="form">
  <div class="row">
    <div class="title-container">
      <span class="title">Incident ID: {{ form.get('incidentId').value !== 0 ? form.get('incidentId').value : 0 }}</span>
      <div class="status-chip" [ngClass]="form.get('status').value === 1 ? 'finalized' : 'draft'">
        <mat-icon>{{ form.get('status').value === 1 ? 'check_circle' : 'schedule' }}</mat-icon>
        <span class="chip" >{{ form.get('status').value === 1 ? 'Finalized' : 'Draft' }}</span>
      </div>    
    </div>
  </div>
  <h2>Main</h2>
  <div class="row">
    <mat-checkbox class="margin" color="primary" [formControl]="form.get('mainDeployed')"
      >Main Parachute Deployed?</mat-checkbox
    >
    <mat-checkbox class="margin" color="primary" [formControl]="form.get('mainCanopyCutaway')"
      >Main Parachute Cutaway?</mat-checkbox
    >
  </div>
  <div class="row">
    <mat-form-field class="autocomplete">
      <mat-label>Main Parachute</mat-label>
      <input
        type="text"
        aria-label="Main Parachute"
        matInput
        [formControl]="form.get('mainParachute')"
        [matAutocomplete]="mainParachuteAuto"
        [required]="
          form.get('mainDeployed').value === true || form.get('mainChuteCutaway').value === true
          "
      />
      <mat-autocomplete
        (optionSelected)="onMainParachuteChange($event)"
        autoActiveFirstOption
        #mainParachuteAuto="matAutocomplete"
        [displayWith]="mainParachuteDisplay"
      >
        <mat-option *ngFor="let chute of filteredMainParachutes$ | async" [value]="chute">
          {{ chute.Base ? chute.Base + ' | ' : ''}}{{ chute.chuteType ? chute.chuteType + ' | ' : '' }}{{ chute.main }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Main Manufacturer</mat-label>
      <mat-select [formControl]="form.get('mainRigManufId')" (selectionChange)="onMainManufChange($event)">
        <mat-option *ngFor="let manufacturer of dropDownMainManufacturers" [value]="manufacturer.id">
          {{ manufacturer.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Jumps to Date</mat-label>
      <input matInput type="number" min="0" [formControl]="form.get('jumpsOnMain')" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>In-Service Date</mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="form.get('mainInServiceDate')" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="autocomplete">
      <mat-label>Rigger</mat-label>
      <input
        type="text"
        aria-label="Rigger"
        matInput
        [formControl]="form.get('mainRiggerDetails')"
        [matAutocomplete]="riggerAuto"
        [required]="
          form.get('mainDeployed').value === true || form.get('mainChuteCutaway').value === true
        "
      />
      <mat-autocomplete
        autoActiveFirstOption
        #riggerAuto="matAutocomplete"
        [displayWith]="riggerDisplay"
        (optionSelected)="onRiggerSelection($event.option.value)"
      >
        <mat-option *ngFor="let rigger of filteredRiggers$ | async" [value]="rigger">
          {{ rigger.firstName || '' }} {{ rigger.lastName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Location</mat-label>
      <mat-select
        [formControl]="form.get('mainRigLocId')"
        (selectionChange)="onBaseChange($event)"
        [required]="
          form.get('mainDeployed').value === true || form.get('mainChuteCutaway').value === true
        "
      >
        <mat-option [value]="null"></mat-option>
        <mat-option *ngFor="let base of riggingLocations" [value]="base.id" >
          {{ base.text }} | {{ base.baseCode }}
        </mat-option>
        <mat-option value="Other">Field (Other)</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Location (Spike)</mat-label>
      <mat-select [formControl]="form.get('mainRiggerSpikeBaseId')" (selectionChange)="onMainSpikeChange($event)">
        <mat-option *ngIf="riggingLocationsSpike" [value]="null"></mat-option>
        <mat-option *ngFor="let base of riggingLocationsSpike" [value]="base.id">
          {{ base.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Date</mat-label>
      <input matInput [matDatepicker]="rigDatePicker" [formControl]="form.get('mainRigDate')" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="rigDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #rigDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="row">
    <h2>Drogue</h2>
  </div>
  <div class="row">
    <mat-form-field class="autocomplete">
      <mat-label>Drogue Parachute</mat-label>
      <input
        type="text"
        aria-label="Drogue Parachute"
        matInput
        [formControl]="form.get('drgName')"
        [matAutocomplete]="drogueParachuteAuto"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #drogueParachuteAuto="matAutocomplete"
        [displayWith]="drogueParachuteDisplay"
        (optionSelected)="onDrogueParachuteChange($event)"
      >
        <mat-option *ngFor="let chute of filteredDrogueParachutes$ | async" [value]="chute">
          {{ chute.Base ? chute.Base + ' | ' : '' }}{{ chute.drogue }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Drogue Manufacturer</mat-label>
      <mat-select [formControl]="form.get('drgRigManufId')" (selectionChange)="onDrogueManufacturerChange($event)" >
        <mat-option *ngFor="let manufacturer of drogueManufacturers" [value]="manufacturer.id">
          {{ manufacturer.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Harness Number</mat-label>
      <input matInput type="text" [formControl]="form.get('harnessNum')" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>In-Service Date</mat-label>
      <input matInput [matDatepicker]="drgPicker" [formControl]="form.get('drgServiceDate')" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="drgPicker"></mat-datepicker-toggle>
      <mat-datepicker #drgPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="autocomplete">
      <mat-label>Rigger</mat-label>
      <input
        type="text"
        aria-label="Drogue Rigger"
        matInput
        [formControl]="form.get('drgRiggerDetails')"
        [matAutocomplete]="drgRiggerAuto"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #drgRiggerAuto="matAutocomplete"
        [displayWith]="riggerDisplay"
        (optionSelected)="onDrogueRiggerSelection($event.option.value)"
      >
        <mat-option *ngFor="let rigger of filteredDrogueRiggers$ | async" [value]="rigger">
          {{ rigger.firstName }} {{ rigger.lastName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Location</mat-label>
      <mat-select
        [formControl]="form.get('drgRigLocationId')"
        (selectionChange)="onDrogueRiggingLocationChange($event)"
      >
        <mat-option [value]="null"></mat-option>
        <mat-option *ngFor="let base of drogueRiggingLocations" [value]="base.id">
          {{ base.text }} | {{ base.baseCode }}
        </mat-option>
        <mat-option value="Other">Field (Other)</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Location (Spike)</mat-label>
      <mat-select [formControl]="form.get('drgRiggerSpikeBaseID')" (selectionChange)="onDrogueSpikeChange($event)">
        <mat-option *ngIf="drogueRiggingLocationsSpike" [value]="null"></mat-option>
        <mat-option *ngFor="let base of drogueRiggingLocationsSpike" [value]="base.id">
          {{ base.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Date</mat-label>
      <input
        matInput
        [matDatepicker]="drgRigDatePicker"
        [formControl]="form.get('drgRiggerDate')"
      />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="drgRigDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #drgRigDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <h2>Reserve</h2>
  <div class="row">
    <mat-checkbox class="margin" color="primary" [formControl]="form.get('reserveDeployed')"
      >Reserve Parachute Deployed?</mat-checkbox
    >
  </div>
  <div class="row">
    <mat-form-field class="autocomplete">
      <mat-label>Reserve Parachute</mat-label>
      <input
        type="text"
        aria-label="Reserve Parachute"
        matInput
        [formControl]="form.get('reserveParachuteDetails')"
        [matAutocomplete]="reserveParachuteAuto"
        [required]="form.get('reserveDeployed').value === true"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #reserveParachuteAuto="matAutocomplete"
        [displayWith]="reserveParachuteDisplay"
        (optionSelected)="onReserveParachuteChange($event)"
      >
        <mat-option *ngFor="let chute of filteredReserveParachutes$ | async" [value]="chute">
          {{ chute.Base ? chute.Base + ' | ' : '' }}{{ chute.reserve }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Reserve Manufacturer</mat-label>
      <mat-select (selectionChange)="onReserveManufacturerChange($event)" [formControl]="form.get('reserveRigManufId')">
        <mat-option *ngFor="let manufacturer of reserveManufacturers" [value]="manufacturer.id">
          {{ manufacturer.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Deployment Method</mat-label>
      <mat-select
        [formControl]="form.get('reserveDeployedBy')"
        [required]="form.get('reserveDeployed').value === true"
      >
        <mat-option *ngFor="let method of deploymentMethods" [value]="method">
          {{ method }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>In-Service Date</mat-label>
      <input
        matInput
        [matDatepicker]="reserveDatePicker"
        [formControl]="form.get('reserveServiceDate')"
      />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="reserveDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #reserveDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="autocomplete">
      <mat-label>Rigger</mat-label>
      <input
        type="text"
        aria-label="Reserve Rigger"
        matInput
        [formControl]="form.get('reserveRiggerDetails')"
        [matAutocomplete]="reserveRiggerAuto"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #reserveRiggerAuto="matAutocomplete"
        [displayWith]="riggerDisplay"
        (optionSelected)="onReserveRiggerSelection($event.option.value)"
      >
        <mat-option *ngFor="let rigger of filteredReserveRiggers$ | async" [value]="rigger">
          {{ rigger.firstName }} {{ rigger.lastName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Location</mat-label>
      <mat-select
        [formControl]="form.get('reserveRigLocId')"
        (selectionChange)="onReserveRiggingLocationChange($event)"
      >
        <mat-option [value]="null"></mat-option>
        <mat-option *ngFor="let base of riggingLocations" [value]="base.id">
          {{ base.text }} | {{ base.baseCode }}
        </mat-option>
        <mat-option value="Other">Field (Other)</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rigging Date</mat-label>
      <input
        matInput
        [matDatepicker]="reserveRigDatePicker"
        [formControl]="form.get('reserveRigDate')"
      />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="reserveRigDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #reserveRigDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <mat-form-field color="primary" class="notes">
    <mat-label>Notes: included is any unassociated legacy information</mat-label>
    <textarea type="text" matInput [formControl]="form.get('parachuteNotes')" rows="5"></textarea>
  </mat-form-field>
</ng-container>
